import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { SimplePage } from '@cp-mx/common';
import { fetchPrivacyPolicy } from './PrivacyPolicySlice';
import { PrivacyPolicyContentSelector } from './PrivacyPolicyContentSelector';

export function usePrivacyPolicy(): AbstractContentState<SimplePage> {
    return useCmsContent(fetchPrivacyPolicy, PrivacyPolicyContentSelector);
}
